// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Video = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.091 10.526V5.321l4.407-2.37.002 9.948-4.409-2.373Zm-1 3.12a.956.956 0 0 1-.955.954H2.706a.956.956 0 0 1-.956-.955V2.205c0-.527.429-.955.956-.955h11.43c.527 0 .955.428.955.955V13.645Zm6.407-11.532a.5.5 0 0 0-.737-.44l-4.67 2.511v-1.98A1.957 1.957 0 0 0 14.136.25H2.706A1.957 1.957 0 0 0 .75 2.205v11.44c0 1.078.877 1.955 1.956 1.955h11.43a1.957 1.957 0 0 0 1.955-1.955v-1.983l4.672 2.514a.5.5 0 0 0 .737-.44l-.002-11.622Z"
			fill="#4A90E2"
		/>
	</svg>
);
export default Video;
